module.exports = __webpack_public_path__ + "static/media/mozza-mb-2023-fr.d8f31a1b.jpg";